// MapContext.js
import { createContext } from "react";

const MapContext = createContext(null);

export default MapContext;
